<template>
  <div
    class="notification is-light content is-normal"
  >
    <h3 v-text="$wording.submission_details.warning_title" />
    <!-- <p v-html="$sprintf($wording.certify.text_8, fieldTitle)" /> -->
    <p v-html="$sprintf($wording.certify.text_failed_inspection_1)" />
    <p v-html="$sprintf($wording.certify.text_failed_inspection_2, unitName, streetAddress)" />
  </div>
</template>

<script>
export default {
  props: {
    unitName: {
      type: String,
      required: true,
    },
    streetAddress: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
